module.exports = __webpack_public_path__ + "img/tx.d090b1c6.png";